import { getBotAppearance } from "./grabBotData";

// ----------------------------------------
// Helpers
// ----------------------------------------
const sanitizeCssColor = (value) => {
  if (typeof value !== "string") return null;

  const style = new Option().style;
  style.color = "";
  style.color = value.trim();
  return style.color !== "" ? style.color : null;
};

const sanitizeChatTheme = (value = "") => {
  const theme = (value || "").trim().toLowerCase();
  return theme === "dark" || theme === "light" ? theme : null;
};

const sanitizeInput = (value) =>
  typeof value === "string" ? value.replace(/[<>\\/]/g, "") : "";

// ----------------------------------------
// CSS Variable Mappings
// ----------------------------------------
const cssVariableMapping = {
  chatBoxBackgroundColor: "--chatBoxBackground",
  chatBoxUserMessageTextColor: "--messageUserText",
  chatBoxUserMessageBackgroundColor: "--messageUserBg",
  chatBoxAIMessageBackgroundColor: "--messageBotBg",
  chatBoxAIMessageTextColor: "--messageBotText",
  chatBoxAIMessageIconColor: "--botIcon",
  chatBoxAIMessageIconBgColor: "--botIconBg",
  chatBoxButtonText: "--buttonText",
  chatBoxButtonBg: "--buttonBg",
  chatBoxError: "--error",
  chatBoxInputText: "--inputText",
  chatBoxInputBg: "--inputBg",
  chatBoxChatTitle: "--chatTitle",
  chatBoxMessageLinks: "--messageLinks",
};

// ----------------------------------------
// Main Build CSS Function
// ----------------------------------------
export const buildCss = async () => {
  const params = new URLSearchParams(window.location.search);
  const useFakeData = params.get("useFakeData") === "true";

  const pathId = sanitizeInput(window.location.pathname);
  const paramId = sanitizeInput(params.get("id") || "");
  const PID = pathId || paramId;

  let cssVariables = ":root {\n";
  let hasVariables = false;
  let botAppearance = [];

  // Apply Theme Class (Dark Mode)
  const applyThemeClass = (theme) => {
    const sanitizedTheme = sanitizeChatTheme(theme);
    if (sanitizedTheme === "dark") {
      document.body.classList.add("dark");
    }
  };

  // Apply CSS Variables from key-value object
  const applyCssVariables = (source = {}, isFromParams = false) => {
    Object.entries(cssVariableMapping).forEach(([sourceKey, cssVar]) => {
      const value = isFromParams
        ? sanitizeCssColor(params.get(sourceKey))
        : source[sourceKey];
      const finalValue = isFromParams ? value : sanitizeCssColor(value);

      if (finalValue) {
        cssVariables += `  ${cssVar}: ${finalValue} !important;\n`;
        hasVariables = true;
      }
    });
  };

  // ----------------------------------------
  // Source: URL Params (Fake Data Mode)
  // ----------------------------------------
  if (useFakeData) {
    applyThemeClass(params.get("chatTheme"));
    applyCssVariables({}, true);

    // ----------------------------------------
    // Source: API Fallback
    // ----------------------------------------
  } else if (PID) {
    try {
      botAppearance = await getBotAppearance(PID);
      if (botAppearance) {
        applyThemeClass(botAppearance.chatTheme);
        applyCssVariables(botAppearance);
      }
    } catch (err) {
      console.error("Failed to load bot appearance:", err);
    }
  }

  // ----------------------------------------
  // Inject CSS Variables
  // ----------------------------------------
  cssVariables += "}\n";

  if (hasVariables) {
    const style = document.createElement("style");
    style.type = "text/css";
    style.textContent = cssVariables;
    document.head.appendChild(style);
  }

  // Set Page Title
  const title = botAppearance?.chatNickname || "Neevai iframe chat";
  document.title = title;
};
